<template>
  <div>
    <section class="SubMenu tw-bg-gradient2-lr tw-py-6">
      <div class="ns-container">
        <h1 class="heading-white tw-text-center">
          All Profiles
        </h1>
      </div>
    </section>

    <section>
      <div class="tw-w-screen tw-p-2">
        <div class="tw-grid tw-grid-cols-2 sm:tw-grid-cols-3 md:tw-grid-cols-4 lg:tw-grid-cols-5 tw-gap-2">
          <ProfileGridItem
            v-for="profile in profiles"
            :key="profile.uuid"
            :data="profile"
            :route="{
              name: 'admin-profile'
            }"
            :options="{
              show: {
                profession: true,
                distanceToUser: false,
                lastOnline: true,
              }
            }"
          />

          <infinite-loading
            identifier="all-profiles"
            spinner="circles"
            @infinite="infiniteHandler"
          >
            <div slot="spinner">
              Loading...
            </div>
            <div slot="no-more">
              No more message
            </div>
            <div slot="no-results">
              No results message
            </div>
          </infinite-loading>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Profile from '@/vuex/orm/models/Profile';

export default {
  name: 'PageProfiles', // important

  components: {
    InfiniteLoading: () => import('vue-infinite-loading'),
    ProfileGridItem: () => import('@/components/profile/ProfileGridItem'),
  },

  data() {
    return {
      page: 1,
      profiles: [],
    };
  },

  methods: {
    infiniteHandler($state) {
      this.$http
        .get('/api/admin/profiles', {
          params: {
            page: this.page,
          },
        })
        .then(({ data }) => {
          if (data.length) {
            this.page += 1;
            this.profiles.push(...data);

            // console.log(data);

            // Profile.insert({
            //   data,
            // });

            // console.log(Profile.query().count());

            $state.loaded();
          } else {
            $state.complete();
          }
        });
    },
  },
};
</script>
